// extracted by mini-css-extract-plugin
module.exports = {"container":"ratioContainerStyles_container__M8ZEJ","overflowHidden":"ratioContainerStyles_overflowHidden__D9qtA"};